'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.session = exports.Session = void 0;
var pubsub_1 = require("../events/pubsub");
var events_1 = require("../events");
var storage_1 = require("../storage");
var methods_1 = require("../methods");
var magic_1 = require("../magic");
var transport_1 = require("../transport");
var Session = /** @class */ (function () {
    function Session() {
        var _this = this;
        this.onChange = events_1.events.sessionChange.bind(events_1.events);
        this.id = null;
        this.ns = 'sid';
        this.userNs = 'user';
        this.user = null;
        this.sessionCheckInterval = null;
        this.isTokenExpired = false;
        this.pendingTokenResolves = [];
        this.keycloakNs = 'keycloak_session';
        this.keycloakSession = null;
        this.id = storage_1.storage.getItem(this.ns) || '';
        var keycloakSession = storage_1.storage.getItem(this.keycloakNs);
        if (keycloakSession) {
            this.keycloakSession = JSON.parse(keycloakSession);
        }
        pubsub_1.pubsub.subscribe(pubsub_1.Topic.SessionExpired, function () { return _this.destroy(); });
        pubsub_1.pubsub.subscribe(pubsub_1.Topic.SessionKickedOut, function () { return _this.destroy(); });
        pubsub_1.pubsub.subscribe(pubsub_1.Topic.SessionLimitationTimeReached, function () {
            return _this.destroy();
        });
        pubsub_1.pubsub.subscribe(pubsub_1.Topic.SessionSelfExclusion, function () { return _this.destroy(); });
        pubsub_1.pubsub.subscribe(pubsub_1.Topic.SessionLoggedOut, function () { return _this.destroy(); });
        pubsub_1.pubsub.subscribe(pubsub_1.Topic.SessionGeoLocation, function () { return _this.destroy(); });
        events_1.events.userUpdated(this.handleUserUpdate.bind(this));
        var currUser = storage_1.storage.getItem(this.userNs);
        if (currUser) {
            this.user = JSON.parse(currUser);
        }
    }
    Session.prototype.getId = function () {
        return this.id;
    };
    Session.prototype.getKeycloakSession = function () {
        return this.keycloakSession;
    };
    // in case the token is expired, we have to wait for it to be refreshed
    // that's why we return a promise instead of a plain string value
    Session.prototype.getAccessToken = function () {
        var _this = this;
        var _a;
        if (!this.isTokenExpired) {
            return Promise.resolve((_a = this.keycloakSession) === null || _a === void 0 ? void 0 : _a.token);
        }
        return new Promise(function (resolve) {
            _this.pendingTokenResolves.push(resolve);
        });
    };
    Session.prototype.getUser = function () {
        return this.user;
    };
    Session.prototype.setSessionId = function (sid) {
        this.id = sid;
        storage_1.storage.setItem(this.ns, sid);
    };
    Session.prototype.create = function (user) {
        var _this = this;
        this.id = user.sessionId;
        this.user = user;
        storage_1.storage.setItem(this.ns, user.sessionId);
        storage_1.storage.setItem(this.userNs, JSON.stringify(user));
        pubsub_1.pubsub.publish(pubsub_1.Topic.SessionCreated);
        // if authenticating through keycloak, we don't do the periodic check
        // since it currently fails and logs out the user
        if (this.keycloakSession) {
            return;
        }
        // TODO: remove manual check when session expiration event is fixed
        this.sessionCheckInterval = setInterval(function () {
            methods_1.users.isLoggedIn().then(function (userIsLoggedIn) {
                if (!userIsLoggedIn) {
                    _this.destroy();
                }
            });
        }, 60000);
    };
    Session.prototype.update = function (user) {
        this.user = user;
        storage_1.storage.setItem(this.userNs, JSON.stringify(user));
    };
    Session.prototype.invalidateAccessToken = function () {
        this.isTokenExpired = true;
    };
    Session.prototype.setKeycloakSession = function (payload) {
        this.keycloakSession = payload;
        storage_1.storage.setItem(this.keycloakNs, payload ? JSON.stringify(payload) : '');
    };
    Session.prototype.refreshKeycloakSession = function (payload) {
        this.setKeycloakSession(payload);
        this.isTokenExpired = false;
        this.pendingTokenResolves.forEach(function (resolve) {
            resolve(payload.token);
        });
        this.pendingTokenResolves = [];
    };
    Session.prototype.destroy = function () {
        var isCorex = transport_1.transport.isCoreX();
        if (this.user) {
            // TODO: Temporary until backend unsubscribes users from tags on logout.
            magic_1.magic.methods.users.unsubscribeFromTags(this.user);
        }
        this.user = null;
        this.keycloakSession = null;
        storage_1.storage.removeItem(this.ns);
        storage_1.storage.removeItem(this.userNs);
        storage_1.storage.removeItem(this.keycloakNs);
        this.isTokenExpired = false;
        this.pendingTokenResolves = [];
        if (!isCorex) {
            pubsub_1.pubsub.publish(pubsub_1.Topic.SessionDestroyed);
        }
        else {
            // we emit a different event due to the issue encountered in
            // https://gaminginnovationgroup.atlassian.net/browse/GWP-7789
            pubsub_1.pubsub.publish(pubsub_1.Topic.SessionDestroyedCoreX);
        }
        if (this.sessionCheckInterval) {
            clearInterval(this.sessionCheckInterval);
            this.sessionCheckInterval = null;
        }
    };
    Session.prototype.isCreated = function () {
        return !!this.user;
    };
    Session.prototype.handleUserUpdate = function (event) {
        if (!this.user) {
            return;
        }
        if (event.roles) {
            var roles = event.roles.map(function (role) { return role.name; });
            this.user.roles = roles || [];
        }
        if (event.segment) {
            this.user.segment = event.segment;
        }
    };
    return Session;
}());
exports.Session = Session;
exports.session = new Session();
